"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const EyeIcon_1 = __importDefault(require("../common/icons/EyeIcon"));
const CloseEyeIcon_1 = __importDefault(require("../common/icons/CloseEyeIcon"));
const DynamicOptionFields = ({ values, onChange, }) => {
    const handleAdd = () => {
        onChange([...values, { value: "", isHidden: false }]);
    };
    const handleRemove = (index) => {
        const updated = values.filter((_, i) => i !== index);
        onChange(updated);
    };
    const handleChange = (index, newValue) => {
        const updated = [...values];
        updated[index].value = newValue;
        updated[index].label = newValue; // Reset visibility when value changes
        onChange(updated);
    };
    const toggleVisibility = (index) => {
        const updated = [...values];
        updated[index].isHidden = !updated[index].isHidden;
        onChange(updated);
    };
    return ((0, jsx_runtime_1.jsx)(material_1.Box, { children: (0, jsx_runtime_1.jsxs)(material_1.Stack, { spacing: 1, children: [values.map((item, index) => ((0, jsx_runtime_1.jsxs)(material_1.Box, { display: "flex", gap: 1, alignItems: "center", children: [(0, jsx_runtime_1.jsx)(material_1.TextField, { variant: "outlined", size: "small", type: "text", value: item.value, onChange: (e) => handleChange(index, e.target.value), fullWidth: true }), (0, jsx_runtime_1.jsx)(material_1.IconButton, { onClick: () => toggleVisibility(index), children: !item.isHidden ? (0, jsx_runtime_1.jsx)(EyeIcon_1.default, {}) : (0, jsx_runtime_1.jsx)(CloseEyeIcon_1.default, {}) }), (0, jsx_runtime_1.jsx)(material_1.IconButton, { color: "error", onClick: () => handleRemove(index), children: (0, jsx_runtime_1.jsx)(icons_material_1.Remove, {}) })] }, index))), (0, jsx_runtime_1.jsx)(material_1.Button, { onClick: handleAdd, startIcon: (0, jsx_runtime_1.jsx)(icons_material_1.Add, {}), variant: "outlined", size: "small", sx: { alignSelf: "flex-start" }, children: "Add" })] }) }));
};
exports.default = DynamicOptionFields;
